import { BaseRequest } from './BaseRequest';

export class RedisRequest extends BaseRequest {
    
}